<template>
  <div  style="padding-left:0px;padding-right:0px;padding-top:20px;margin-top:50px;margin-left:0px;margin-right:0px;height:10px">  
    <v-icon @click="$router.go(-1)" >fas fa-arrow-circle-left</v-icon>
  </div>
</template>
<script>
  export default {
    data: () => ({
      items: [
        {
          text: 'Back',
          disabled: false,
          href: this.$router.go(n) 
        }
      ]
    })
  }
</script>